import { cva } from 'class-variance-authority'
import { cn } from '../../lib/utils.js'

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-sm border px-2.5 py-1 text-xs font-semibold leading-none',
  {
    variants: {
      variant: {
        default: 'border-blue-200 bg-blue-50 text-primary',
        secondary: 'border-border bg-slate-50 text-text-secondary',
        success: 'border-green-200 bg-green-50 text-success',
        warning: 'border-amber-200 bg-amber-50 text-warning',
        danger: 'border-red-200 bg-red-50 text-danger',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

function Badge({ className, variant, ...props }) {
  return (
    <span
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  )
}

export { Badge }
